import React from 'react';
import PropTypes from 'prop-types';
import { OurTeam } from '../../../core/OurTeam';
import { StyledSummaryProfile } from './style';

const Department = ({ className, dataUser, ourTeam }) => (
  <div className={className}>
    <StyledSummaryProfile dataUser={dataUser} />
    {ourTeam && ourTeam.dataTeam && (
      <OurTeam
        title={ourTeam.title}
        text={ourTeam.text}
        dataTeam={ourTeam.dataTeam}
      />
    )}
  </div>
);

Department.propsType = {
  className: PropTypes.string,
  dataUser: PropTypes.shape({
    extension: PropTypes.string,
    mobile: PropTypes.string,
    address: PropTypes.string,
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    linkedin: PropTypes.string,
    instagram: PropTypes.string,
    vimeo: PropTypes.string
  }),
  ourTeam: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    dataTeam: PropTypes.shape({
      person: PropTypes.string,
      job: PropTypes.string
    }),
    dataTeams: PropTypes.shape({
      title: PropTypes.string,
      mainId: PropTypes.string,
      secondaryId: PropTypes.string,
      team: PropTypes.shape({
        person: PropTypes.string,
        job: PropTypes.string
      })
    })
  })
};

export default Department;
